export default __webpack_public_path__ + "static/media/rs.9e5c1607.svg";